import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, Col, Form, Row, Table, Badge } from 'react-bootstrap';
import Select, { components } from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import { useDispatch, useSelector } from 'react-redux';
import PreciosProveedorModal from './modals/PreciosProveedorModal';
import SeleccionUbicacionesModal from './modals/SeleccionUbicacionesModal';
import SeleccionPaqueteModal from './modals/SeleccionPaqueteModal';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import { setAlert } from '../../actions/alert';
import {
    buscarClientesVenta,
    crearClienteVenta,
    listarMetodosVenta,
    crearVenta,
    limpiarVentaCreada,
    cargarCategoriasVenta,
    cargarSubcategoriasVenta,
    limpiarSubcategoriasVenta,
    buscarProductosInventarioVenta,
    limpiarProductosInventarioVenta,
    cargarDetalleProductoVenta,
    limpiarDetalleProductoVenta,
    generarPdfVenta
} from '../../actions/ventas';
import { buscarPaquetes, limpiarPaquetes } from '../../actions/configuracion';

import AgregarClienteModal from './modals/AgregarClienteModal';

const TIPO_OPTIONS = [
    { value: 0, label: 'Venta' },
    { value: 1, label: 'Cotización' }
];

const formatMoney = (value) => {
    const v = Number(value || 0);
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(v);
};

const formatNumber = (value) => {
    const v = Number(value || 0);
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v);
};

const buildRowKey = (productoId, sel) => {
    if (sel?.sinInventario) return `${productoId || 'np'}-sinubic`;
    const a = sel?.areaId || 'na';
    const o = sel?.organizadorId || 'null';
    const u = sel?.ubicacionId || 'null';
    return `${productoId || 'np'}-${a}-${o}-${u}`;
};

const NoOptionsClientes = (props) => {
    const inputValue = (props.selectProps.inputValue || '').trim();
    const isLoading = !!props.selectProps.isLoading;

    if (!inputValue) {
        return (
            <components.NoOptionsMessage {...props}>
                Escribe para buscar
            </components.NoOptionsMessage>
        );
    }

    if (isLoading) {
        return (
            <components.NoOptionsMessage {...props}>
                Buscando...
            </components.NoOptionsMessage>
        );
    }

    return (
        <components.NoOptionsMessage {...props}>
            <div className="text-muted mb-2">Sin resultados</div>
            <button
                type="button"
                className="btn btn-outline-primary btn-sm w-100"
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof props.selectProps.onAgregarCliente === 'function') {
                        props.selectProps.onAgregarCliente();
                    }
                }}
            >
                Agregar nuevo cliente
            </button>
        </components.NoOptionsMessage>
    );
};

export default function NuevaVenta() {
    const dispatch = useDispatch();

    const {
        metodos,
        categoriasVenta,
        subcategoriasVenta,
        productosInventario,
        ventaCreada
    } = useSelector((state) => state.ventas);

    const { listado: paquetesBusqueda } = useSelector((state) => state.configuracion?.paquetes || { listado: [] });

    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
    const [clienteInput, setClienteInput] = useState('');
    const [clientesEncontrados, setClientesEncontrados] = useState([]);
    const [loadingClientes, setLoadingClientes] = useState(false);
    const [showNuevoCliente, setShowNuevoCliente] = useState(false);
    const [savingCliente, setSavingCliente] = useState(false);

    const [tipoSeleccionado, setTipoSeleccionado] = useState(TIPO_OPTIONS[0]);
    const [metodoSeleccionado, setMetodoSeleccionado] = useState(null);
    const [cobroInmediato, setCobroInmediato] = useState(true);
    const [moneda, setMoneda] = useState(0);
    const [tipoCambioUsd, setTipoCambioUsd] = useState('1');

    const [categoriaSel, setCategoriaSel] = useState(null);
    const [subcategoriaSel, setSubcategoriaSel] = useState(null);
    const [codigoTienda, setCodigoTienda] = useState('');
    const [codigoProveedor, setCodigoProveedor] = useState('');
    const [nombreBusquedaInput, setNombreBusquedaInput] = useState('');
    const [buscandoProductos, setBuscandoProductos] = useState(false);

    const [showUbicaciones, setShowUbicaciones] = useState(false);
    const [detalleActual, setDetalleActual] = useState(null);

    const [items, setItems] = useState([]);

    const [busquedaPaquete, setBusquedaPaquete] = useState('');
    const [buscandoPaquetes, setBuscandoPaquetes] = useState(false);
    const [showSeleccionPaquete, setShowSeleccionPaquete] = useState(false);
    const [paqueteActual, setPaqueteActual] = useState(null);
    const [paquetesItems, setPaquetesItems] = useState([]);
    const [paquetesExpandidos, setPaquetesExpandidos] = useState({});

    const [showPreciosProveedor, setShowPreciosProveedor] = useState(false);
    const [preciosContexto, setPreciosContexto] = useState({
        productoNombre: '',
        codigoTienda: '',
        precios: []
    });

    const clientTimerRef = useRef(null);
    const productTimerRef = useRef(null);
    const paqueteTimerRef = useRef(null);
    const tcRef = useRef(1);

    const disabledAll = !!ventaCreada;
    const esCotizacion = tipoSeleccionado?.value === 1;
    /* Sin cliente, el cobro siempre es en el momento (una venta a crédito requiere poder cobrarle a alguien) */
    const esCobradaInmediato = !clienteSeleccionado?.value || cobroInmediato;

    const getTc = () => {
        const tc = Number(tipoCambioUsd);
        return Number.isFinite(tc) && tc > 0 ? tc : 1;
    };

    const validarTipoCambioSiUSD = () => {
        if (Number(moneda) !== 1) return true;
        const tc = Number(tipoCambioUsd);
        return Number.isFinite(tc) && tc > 0;
    };

    const prefMoneda = Number(moneda) === 1 ? 'USD $' : '$';

    /* Al cambiar de moneda, reconvierte los precios ya capturados (manuales o de catálogo)
       usando el tipo de cambio actual, para que no se queden con el número crudo de la otra moneda. */
    const onChangeMoneda = (nextRaw) => {
        const nextVal = Number(nextRaw);
        const prevVal = Number(moneda);
        if (nextVal === prevVal) {
            setMoneda(nextVal);
            return;
        }

        const tc = getTc();

        setItems((prev) => prev.map((it) => {
            let precio = Number(it.precio || 0);
            let precioBase = Number(it.precioBase || 0);

            if (prevVal === 0 && nextVal === 1) {
                precio = precio / tc;
                precioBase = precioBase / tc;
            } else if (prevVal === 1 && nextVal === 0) {
                precio = precio * tc;
                precioBase = precioBase * tc;
            }

            return {
                ...it,
                precio: Number(precio.toFixed(3)),
                precioBase: Number(precioBase.toFixed(6))
            };
        }));

        setPaquetesItems((prev) => prev.map((it) => {
            let precio = Number(it.precio || 0);
            if (prevVal === 0 && nextVal === 1) precio = precio / tc;
            else if (prevVal === 1 && nextVal === 0) precio = precio * tc;
            return { ...it, precio: Number(precio.toFixed(3)) };
        }));

        tcRef.current = tc;
        setMoneda(nextVal);
    };

    /* Si el usuario corrige el tipo de cambio después de haber agregado productos (ej. los agregó
       con el valor default "1" y luego lo ajusta), reescala los precios ya capturados por la razón
       entre el TC anterior y el nuevo — no solo al momento de cambiar de moneda. */
    const onChangeTipoCambio = (nextRaw) => {
        setTipoCambioUsd(nextRaw);

        if (Number(moneda) !== 1) return;

        const nextTc = Number(nextRaw);
        if (!Number.isFinite(nextTc) || nextTc <= 0) return;

        const prevTc = tcRef.current;
        if (nextTc === prevTc) return;

        setItems((prev) => prev.map((it) => {
            const precio = Number(it.precio || 0) * (prevTc / nextTc);
            const precioBase = Number(it.precioBase || 0) * (prevTc / nextTc);
            return {
                ...it,
                precio: Number(precio.toFixed(3)),
                precioBase: Number(precioBase.toFixed(6))
            };
        }));

        setPaquetesItems((prev) => prev.map((it) => ({
            ...it,
            precio: Number((Number(it.precio || 0) * (prevTc / nextTc)).toFixed(3))
        })));

        tcRef.current = nextTc;
    };

    const menuPortalTarget = useMemo(() => {
        if (typeof document === 'undefined') return null;
        return document.body;
    }, []);

    const metodosOptions = useMemo(() => {
        return (Array.isArray(metodos) ? metodos : []).map((m) => ({
            value: m?._id || null,
            label: m?.nombre || ''
        }));
    }, [metodos]);

    const categoriasOptions = useMemo(() => {
        return (Array.isArray(categoriasVenta) ? categoriasVenta : []).map((c) => ({
            value: c?._id || c?.id || null,
            label: c?.nombre || 'Sin definir'
        }));
    }, [categoriasVenta]);

    const subcategoriasOptions = useMemo(() => {
        return (Array.isArray(subcategoriasVenta) ? subcategoriasVenta : []).map((s) => ({
            value: s?._id || s?.id || null,
            label: s?.nombre || 'Sin definir'
        }));
    }, [subcategoriasVenta]);

    const productosOptions = useMemo(() => {
        const arr = Array.isArray(productosInventario) ? productosInventario : [];
        const filtrados = esCotizacion ? arr : arr.filter((p) => Number(p?.cantidad || 0) > 0);
        return filtrados.map((p) => {
            const stock = Number(p?.cantidad || 0);
            const cod = p?.codigo_tienda ? ` · ${p.codigo_tienda}` : '';
            return {
                value: p?._id || null,
                label: `${p?.nombre || ''}${cod} · Stock: ${formatNumber(stock)}`,
                raw: p
            };
        });
    }, [productosInventario, esCotizacion]);

    const clienteOptions = useMemo(() => {
        return (Array.isArray(clientesEncontrados) ? clientesEncontrados : []).map((c) => ({
            value: c?._id || null,
            label: `${c?.nombre || ''}${c?.telefono ? ` (${c.telefono})` : ''}`,
            raw: c
        }));
    }, [clientesEncontrados]);

    const paquetesOptions = useMemo(() => {
        return (Array.isArray(paquetesBusqueda) ? paquetesBusqueda : []).map((p) => ({
            value: p?._id || null,
            label: `${p?.nombre || ''}${p?.codigo ? ` · ${p.codigo}` : ''}`,
            raw: p
        }));
    }, [paquetesBusqueda]);

    const total = useMemo(() => {
        const totalProductos = items.reduce((acc, it) => {
            const precio = Number(it?.precio || 0);
            const cantidad = Number(it?.cantidad || 0);
            const base = precio * cantidad;
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        const totalPaquetes = paquetesItems.reduce((acc, it) => {
            const precio = Number(it?.precio || 0);
            const cantidad = Number(it?.cantidad || 0);
            const base = precio * cantidad;
            return acc + (it.iva ? base * 1.16 : base);
        }, 0);

        return totalProductos + totalPaquetes;
    }, [items, paquetesItems]);

    const algunFiltro = !!(
        categoriaSel?.value ||
        subcategoriaSel?.value ||
        (codigoTienda || '').trim() ||
        (codigoProveedor || '').trim() ||
        (nombreBusquedaInput || '').trim()
    );

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: false, nombre: 'Ventas', path: `/ventas/` },
            { activo: true, nombre: 'Nueva Venta', path: `/ventas/nueva` }
        ]));
    }, [dispatch]);

    useEffect(() => {
        dispatch(listarMetodosVenta());
        dispatch(limpiarVentaCreada());
        dispatch(cargarCategoriasVenta());

        return () => {
            dispatch(limpiarProductosInventarioVenta());
            dispatch(limpiarSubcategoriasVenta());
            dispatch(limpiarDetalleProductoVenta());
            dispatch(limpiarPaquetes());
        };
    }, [dispatch]);

    useEffect(() => {
        if (disabledAll) {
            setClientesEncontrados([]);
            setLoadingClientes(false);
            return;
        }

        const busqueda = (clienteInput || '').trim();

        if (!busqueda) {
            setClientesEncontrados([]);
            setLoadingClientes(false);
            return;
        }

        if (clientTimerRef.current) {
            clearTimeout(clientTimerRef.current);
        }

        setLoadingClientes(true);

        clientTimerRef.current = setTimeout(async () => {
            const res = await dispatch(buscarClientesVenta(busqueda));
            const arr = Array.isArray(res) ? res : [];
            setClientesEncontrados(arr);
            setLoadingClientes(false);
        }, 350);

        return () => {
            if (clientTimerRef.current) {
                clearTimeout(clientTimerRef.current);
            }
        };
    }, [clienteInput, dispatch, disabledAll]);

    useEffect(() => {
        if (disabledAll) return;

        const idCat = categoriaSel?.value || null;
        const idSub = subcategoriaSel?.value || null;
        const ct = (codigoTienda || '').trim();
        const cp = (codigoProveedor || '').trim();
        const n = (nombreBusquedaInput || '').trim();

        const hayFiltro = !!(idCat || idSub || ct || cp || n);

        if (!hayFiltro) {
            dispatch(limpiarProductosInventarioVenta());
            setBuscandoProductos(false);
            return;
        }

        if (productTimerRef.current) {
            clearTimeout(productTimerRef.current);
        }

        setBuscandoProductos(true);

        productTimerRef.current = setTimeout(async () => {
            await dispatch(buscarProductosInventarioVenta({
                id_categoria: idCat,
                id_subcategoria: idSub,
                nombre: n ? n : null,
                codigo_tienda: ct ? ct : null,
                codigo_proveedor: cp ? cp : null
            }));
            setBuscandoProductos(false);
        }, 450);

        return () => {
            if (productTimerRef.current) {
                clearTimeout(productTimerRef.current);
            }
        };
    }, [categoriaSel, subcategoriaSel, codigoTienda, codigoProveedor, nombreBusquedaInput, disabledAll, dispatch]);

    useEffect(() => {
        if (disabledAll) return;

        const q = (busquedaPaquete || '').trim();

        if (!q) {
            dispatch(limpiarPaquetes());
            setBuscandoPaquetes(false);
            return;
        }

        if (paqueteTimerRef.current) {
            clearTimeout(paqueteTimerRef.current);
        }

        setBuscandoPaquetes(true);

        paqueteTimerRef.current = setTimeout(async () => {
            await dispatch(buscarPaquetes({ busqueda: q }));
            setBuscandoPaquetes(false);
        }, 450);

        return () => {
            if (paqueteTimerRef.current) {
                clearTimeout(paqueteTimerRef.current);
            }
        };
    }, [busquedaPaquete, disabledAll, dispatch]);

    const onSelectCliente = (opt) => {
        if (!opt) {
            setClienteSeleccionado(null);
            return;
        }

        setClienteSeleccionado(opt);
        setClienteInput('');
    };

    const guardarNuevoCliente = async (data) => {
        setSavingCliente(true);
        const cliente = await dispatch(crearClienteVenta(data));
        setSavingCliente(false);

        if (!cliente?._id) {
            return;
        }

        const opt = {
            value: cliente._id,
            label: `${cliente?.nombre || ''}${cliente?.telefono ? ` (${cliente.telefono})` : ''}`,
            raw: cliente
        };

        setClientesEncontrados([cliente]);
        setClienteSeleccionado(opt);
        setClienteInput('');
        setShowNuevoCliente(false);
    };

    const onChangeCategoria = (opt) => {
        setCategoriaSel(opt || null);
        setSubcategoriaSel(null);

        if (opt?.value) {
            dispatch(cargarSubcategoriasVenta(opt.value));
        } else {
            dispatch(limpiarSubcategoriasVenta());
        }
    };

    const onSelectProducto = async (opt) => {
        if (disabledAll) return;
        if (!opt?.raw?._id) return;

        const detalle = await dispatch(cargarDetalleProductoVenta(opt.raw._id));
        if (!detalle) return;

        const inventarios = Array.isArray(detalle.inventarios) ? detalle.inventarios : [];

        if (!esCotizacion && inventarios.length === 0) {
            dispatch(setAlert('El producto no tiene existencia disponible', 'danger'));
            return;
        }

        setDetalleActual(detalle);
        setShowUbicaciones(true);
    };

    const construirFila = (detalle, sel, precioBase, proveedoresNorm, precioEnMonedaActiva) => {
        const unidades = Array.isArray(detalle?.unidades) ? detalle.unidades : [];
        const unidadDefault = unidades.length > 0 ? unidades[0] : null;
        const unidadId = unidadDefault?.unidad?._id || null;
        const unidadNombre = unidadDefault?.unidad?.nombre || null;
        const conversion = Number(unidadDefault?.cantidad || 1) || 1;
        /* precioBase llega en MXN cuando viene del catálogo (precio de proveedor) y se convierte a la
           moneda activa; si ya se capturó directamente en esa moneda (precio libre, sin inventario),
           se usa tal cual. */
        const precioBaseConvertido = (Number(moneda) === 1 && !precioEnMonedaActiva)
            ? (Number(precioBase || 0) / getTc())
            : Number(precioBase || 0);
        const precio = Number((precioBaseConvertido / conversion).toFixed(3));

        return {
            key: buildRowKey(detalle?._id, sel),
            productoId: detalle?._id || null,
            productoNombre: detalle?.nombre || '',
            codigoTienda: detalle?.codigo_tienda || '',
            precios: Array.isArray(proveedoresNorm) ? proveedoresNorm : [],
            areaId: sel.areaId,
            organizadorId: sel.organizadorId,
            ubicacionId: sel.ubicacionId,
            ubicacionLabel: sel.ubicacionLabel,
            inventarioBase: Number(sel.inventarioBase || 0),
            sinInventario: !!sel.sinInventario,
            unidades,
            unidadId,
            unidadNombre,
            conversion,
            precioBase: precioBaseConvertido,
            precio,
            cantidad: Number(sel.cantidad || 0),
            iva: false
        };
    };

    const onConfirmUbicaciones = ({ precioBase, precioEnMonedaActiva, proveedoresNorm, selecciones }) => {
        setShowUbicaciones(false);

        const detalle = detalleActual;
        if (!detalle) return;

        const seleccionadas = Array.isArray(selecciones) ? selecciones.filter((s) => Number(s?.cantidad || 0) > 0) : [];

        if (seleccionadas.length === 0) {
            setDetalleActual(null);
            return;
        }

        setItems((prev) => {
            const copy = [...prev];
            seleccionadas.forEach((sel) => {
                const fila = construirFila(detalle, sel, precioBase, proveedoresNorm, precioEnMonedaActiva);
                const idx = copy.findIndex((x) => x.key === fila.key);
                if (idx >= 0) {
                    copy[idx] = {
                        ...copy[idx],
                        cantidad: Number(copy[idx].cantidad || 0) + fila.cantidad
                    };
                } else {
                    copy.push(fila);
                }
            });
            return copy;
        });

        setDetalleActual(null);
        dispatch(setAlert('Producto agregado', 'success'));
    };

    const cerrarUbicaciones = () => {
        setShowUbicaciones(false);
        setDetalleActual(null);
    };

    const onSelectPaquete = (opt) => {
        if (disabledAll) return;
        if (!opt?.raw?._id) return;

        setPaqueteActual(opt.raw);
        setShowSeleccionPaquete(true);
    };

    const onConfirmPaquete = (data) => {
        setShowSeleccionPaquete(false);
        setPaqueteActual(null);

        setPaquetesItems((prev) => ([
            ...prev,
            { key: `${data.paqueteId}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, ...data }
        ]));

        dispatch(setAlert('Paquete agregado', 'success'));
    };

    const cerrarSeleccionPaquete = () => {
        setShowSeleccionPaquete(false);
        setPaqueteActual(null);
    };

    const togglePaqueteExpandido = (key) => {
        setPaquetesExpandidos((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const eliminarPaqueteItem = (key) => {
        setPaquetesItems((prev) => prev.filter((x) => x.key !== key));
    };

    const setPaqueteItemField = (key, field, value) => {
        setPaquetesItems((prev) => prev.map((x) => (x.key === key ? { ...x, [field]: value } : x)));
    };

    const eliminarItem = (key) => {
        setItems((prev) => prev.filter((x) => x.key !== key));
    };

    const setItemField = (key, field, value) => {
        setItems((prev) => {
            const target = prev.find((x) => x.key === key);
            const productoId = target?.productoId || null;
            return prev.map((x) => {
                if (x.key === key) return { ...x, [field]: value };
                if (field === 'iva' && productoId && x.productoId === productoId) {
                    return { ...x, iva: value };
                }
                return x;
            });
        });
    };

    const onChangeUnidad = (key, unidadOpt) => {
        const unidadId = unidadOpt?.value || null;
        const unidadNombre = unidadOpt?.label || null;

        setItems((prev) =>
            prev.map((x) => {
                if (x.key !== key) return x;

                const found = (Array.isArray(x.unidades) ? x.unidades : []).find((u) => u?.unidad?._id === unidadId);
                const conversion = Number(found?.cantidad || 1);

                return {
                    ...x,
                    unidadId,
                    unidadNombre,
                    conversion,
                    precio: Number(((Number(x.precioBase || 0)) / (Number(conversion || 1) || 1)).toFixed(3))
                };
            })
        );
    };

    const abrirPreciosProveedor = (it) => {
        setPreciosContexto({
            productoNombre: it?.productoNombre || '',
            codigoTienda: it?.codigoTienda || '',
            precios: Array.isArray(it?.precios) ? it.precios : []
        });
        setShowPreciosProveedor(true);
    };

    const cerrarPreciosProveedor = () => {
        setShowPreciosProveedor(false);
        setPreciosContexto({
            productoNombre: '',
            codigoTienda: '',
            precios: []
        });
    };

    const registrarVenta = async () => {
        if (disabledAll) return;

        const idMetodo = esCotizacion ? null : (metodoSeleccionado?.value || null);
        const idCliente = clienteSeleccionado?.value || null;

        if (!esCotizacion && !idCliente && !esCobradaInmediato) {
            dispatch(setAlert('Una venta a crédito requiere un cliente', 'danger'));
            return;
        }

        if (!esCotizacion && esCobradaInmediato && !idMetodo) {
            dispatch(setAlert('El cobro en el momento requiere un método de pago', 'danger'));
            return;
        }

        if (!validarTipoCambioSiUSD()) {
            dispatch(setAlert('Tipo de cambio inválido', 'danger'));
            return;
        }

        if (!items.length && !paquetesItems.length) {
            dispatch(setAlert('Agrega al menos un producto o paquete', 'danger'));
            return;
        }

        const invalid = items.find((it) => {
            const cantidad = Number(it?.cantidad || 0);
            const precio = Number(it?.precio || 0);

            if (!it?.productoId) return true;
            if (cantidad <= 0) return true;
            if (precio < 0) return true;

            if (it?.sinInventario || esCotizacion) return false;

            const inventario = Number(it?.inventarioBase || 0) * Number(it?.conversion || 1);
            if (cantidad > inventario) return true;
            return false;
        });

        if (invalid) {
            dispatch(setAlert('Revisa cantidades, inventario y precios. Hay productos excedidos o inválidos.', 'danger'));
            return;
        }

        const invalidPaquete = paquetesItems.find((it) => {
            const cantidad = Number(it?.cantidad || 0);
            const precio = Number(it?.precio || 0);

            if (!it?.paqueteId) return true;
            if (cantidad <= 0) return true;
            if (precio < 0) return true;
            if (esCotizacion) return false;

            const componentes = Array.isArray(it?.componentes) ? it.componentes : [];
            return componentes.some((c) => !c?.ubicacionId && !c?.areaId);
        });

        if (invalidPaquete) {
            dispatch(setAlert('Revisa cantidades y ubicaciones de los paquetes. Hay paquetes inválidos.', 'danger'));
            return;
        }

        const productos = items.map((it) => ({
            producto: it.productoId,
            unidad: it.unidadId || null,
            cantidad: Number(it.cantidad || 0),
            precio: Number(it.precio || 0),
            conversion: Number(it.conversion || 1),
            area: it.areaId || null,
            organizador: it.organizadorId || null,
            ubicacion: it.ubicacionId || null,
            iva: it.iva || false
        }));

        const paquetes = paquetesItems.map((it) => {
            const cantidadPaquetes = Number(it.cantidad || 0);
            return {
                paquete: it.paqueteId,
                cantidad: cantidadPaquetes,
                precio: Number(it.precio || 0),
                iva: it.iva || false,
                componentes: (Array.isArray(it.componentes) ? it.componentes : []).map((c) => {
                    const conversion = Number(c.conversion || 1) || 1;
                    const cantidadComponente = (Number(c.cantidadPorPaquete || 0) * cantidadPaquetes) / conversion;
                    return {
                        producto: c.productoId,
                        cantidad: cantidadComponente,
                        area: c.areaId || null,
                        organizador: c.organizadorId || null,
                        ubicacion: c.ubicacionId || null
                    };
                })
            };
        });

        await dispatch(crearVenta({
            id_cliente: idCliente || null,
            id_metodo: idMetodo,
            tipo: tipoSeleccionado?.value ?? 0,
            cobro_inmediato: esCotizacion ? null : esCobradaInmediato,
            moneda: Number(moneda) === 1 ? 1 : 0,
            tipo_cambio: Number(moneda) === 1 ? getTc() : 1,
            total: Number(total || 0),
            productos,
            paquetes
        }));
    };

    return (
        <Fragment>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <div className="d-flex align-items-center gap-2">
                        <h3 className="mb-0">Nueva Venta</h3>
                        {ventaCreada?.folio ? <Badge bg="success">Folio: {ventaCreada.folio}</Badge> : null}
                    </div>
                    <div className="text-muted mt-1" style={{ fontSize: 13 }}>
                        Cliente opcional. Filtra productos y selecciona uno para elegir ubicaciones y cantidades.
                    </div>
                </div>
            </div>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <Row className="g-3 align-items-end">
                        <Col md={4}>
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div className="text-muted" style={{ fontSize: 12 }}>Cliente (opcional)</div>
                                {loadingClientes ? <span className="text-muted" style={{ fontSize: 12 }}>Buscando...</span> : null}
                            </div>
                            <Select
                                placeholder="Escribe para buscar..."
                                isClearable
                                isDisabled={disabledAll}
                                isLoading={loadingClientes}
                                value={clienteSeleccionado}
                                inputValue={clienteInput}
                                onInputChange={(val, meta) => {
                                    if (meta.action === 'input-change') {
                                        setClienteInput(val);
                                    }
                                }}
                                onChange={onSelectCliente}
                                options={clienteOptions}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                components={{ NoOptionsMessage: NoOptionsClientes }}
                                onAgregarCliente={() => setShowNuevoCliente(true)}
                            />
                        </Col>

                        <Col md={2}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Tipo</div>
                            <Select
                                isDisabled={disabledAll}
                                value={tipoSeleccionado}
                                onChange={(opt) => setTipoSeleccionado(opt)}
                                options={TIPO_OPTIONS}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                isSearchable={false}
                            />
                        </Col>

                        <Col md={1}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Moneda</div>
                            <Form.Select
                                value={moneda}
                                disabled={disabledAll}
                                onChange={(e) => onChangeMoneda(e.target.value)}
                            >
                                <option value={0}>MXN</option>
                                <option value={1}>USD</option>
                            </Form.Select>
                        </Col>

                        <Col md={1}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>T. Cambio</div>
                            <Form.Control
                                type="number"
                                min="0"
                                value={Number(moneda) === 1 ? tipoCambioUsd : '1'}
                                onChange={(e) => onChangeTipoCambio(e.target.value)}
                                disabled={disabledAll || Number(moneda) !== 1}
                            />
                        </Col>

                        {!esCotizacion && (
                            <Col md={2}>
                                <div className="text-muted mb-1" style={{ fontSize: 12 }}>&nbsp;</div>
                                <Form.Check
                                    type="checkbox"
                                    id="cobro-inmediato"
                                    label="Cobro inmediato"
                                    checked={esCobradaInmediato}
                                    disabled={disabledAll || !clienteSeleccionado?.value}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setCobroInmediato(checked);
                                        if (!checked) setMetodoSeleccionado(null);
                                    }}
                                />
                            </Col>
                        )}

                        {!esCotizacion && (
                            <Col md={2}>
                                <div className="text-muted mb-1" style={{ fontSize: 12 }}>
                                    Método de pago{esCobradaInmediato ? '' : ' (opcional)'}
                                </div>
                                <Select
                                    placeholder="Selecciona método"
                                    isClearable
                                    isDisabled={disabledAll || !esCobradaInmediato}
                                    value={metodoSeleccionado}
                                    onChange={(opt) => setMetodoSeleccionado(opt || null)}
                                    options={metodosOptions}
                                    menuPortalTarget={menuPortalTarget}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                    }}
                                    noOptionsMessage={() => 'Sin métodos'}
                                />
                            </Col>
                        )}
                    </Row>

                    {!esCotizacion && !esCobradaInmediato && (
                        <div className="alert alert-warning mt-3 mb-0" style={{ fontSize: 13 }}>
                            Venta a crédito: se sumará al saldo pendiente del cliente en su cuenta.
                        </div>
                    )}
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Buscar productos</div>
                        {buscandoProductos ? <span className="text-muted" style={{ fontSize: 12 }}>Buscando...</span> : null}
                    </div>

                    <Row className="g-3 align-items-end">
                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Categoría</div>
                            <Select
                                placeholder="Categoría"
                                isClearable
                                isDisabled={disabledAll}
                                value={categoriaSel}
                                onChange={onChangeCategoria}
                                options={categoriasOptions}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() => 'Sin categorías'}
                            />
                        </Col>

                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Subcategoría</div>
                            <Select
                                placeholder="Subcategoría"
                                isClearable
                                isDisabled={disabledAll || !categoriaSel?.value}
                                value={subcategoriaSel}
                                onChange={(opt) => setSubcategoriaSel(opt || null)}
                                options={subcategoriasOptions}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() => 'Sin subcategorías'}
                            />
                        </Col>

                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Código tienda</div>
                            <Form.Control
                                type="text"
                                placeholder="Ej. IN018"
                                value={codigoTienda}
                                disabled={disabledAll}
                                onChange={(e) => setCodigoTienda(e.target.value)}
                            />
                        </Col>

                        <Col md={3}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Código proveedor</div>
                            <Form.Control
                                type="text"
                                placeholder="Ej. TBA-033"
                                value={codigoProveedor}
                                disabled={disabledAll}
                                onChange={(e) => setCodigoProveedor(e.target.value)}
                            />
                        </Col>

                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Nombre</div>
                            <Form.Control
                                type="text"
                                placeholder="Nombre del producto"
                                value={nombreBusquedaInput}
                                disabled={disabledAll}
                                onChange={(e) => setNombreBusquedaInput(e.target.value)}
                            />
                        </Col>

                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Producto</div>
                            <Select
                                placeholder="Selecciona un producto de los resultados..."
                                isDisabled={disabledAll}
                                value={null}
                                onChange={onSelectProducto}
                                options={productosOptions}
                                isLoading={buscandoProductos}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() =>
                                    buscandoProductos
                                        ? 'Buscando...'
                                        : (algunFiltro ? 'Sin resultados' : 'Aplica un filtro para buscar')
                                }
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Productos</div>
                        <div className="d-flex align-items-center gap-2">
                            <div className="text-muted">Total</div>
                            <div className="fs-5 fw-bold">{prefMoneda} {formatMoney(total)}</div>
                        </div>
                    </div>

                    {items.length === 0 ? (
                        <div className="text-muted" style={{ padding: '18px 0' }}>
                            Aún no hay productos. Busca uno y agrégalo.
                        </div>
                    ) : (
                        <div className="table-responsive" style={{ overflow: 'visible' }}>
                            <Table bordered hover className="mb-0" style={{ overflow: 'visible' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 110 }}>Código INRA</th>
                                        <th>Producto</th>
                                        <th>Ubicación</th>
                                        <th style={{ width: 190 }}>$ Venta</th>
                                        <th style={{ width: 70 }} className="text-center">IVA</th>
                                        <th style={{ width: 150 }}>Inventario</th>
                                        <th style={{ width: 150 }}>Cantidad</th>
                                        <th style={{ width: 240 }}>Unidad</th>
                                        <th style={{ width: 150 }}>Subtotal</th>
                                        <th style={{ width: 130 }}>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((it) => {
                                        const unidadesOptions = (Array.isArray(it.unidades) ? it.unidades : []).map((u) => ({
                                            value: u?.unidad?._id || null,
                                            label: u?.unidad?.nombre || ''
                                        }));

                                        const unidadValue = it.unidadId
                                            ? { value: it.unidadId, label: it.unidadNombre || '' }
                                            : null;

                                        const inventarioMostrado = Number(it.inventarioBase || 0) * Number(it.conversion || 1);
                                        const cantidad = Number(it.cantidad || 0);
                                        const isOver = (it.sinInventario || esCotizacion) ? false : cantidad > inventarioMostrado;
                                        const subtotal = Number(it.precio || 0) * cantidad * (it.iva ? 1.16 : 1);

                                        return (
                                            <tr key={it.key} className={isOver ? 'table-danger' : ''}>
                                                <td>
                                                    <div className="fw-semibold">{it.codigoTienda || '-'}</div>
                                                </td>
                                                <td>
                                                    <div className="fw-semibold">{it.productoNombre}</div>
                                                </td>
                                                <td>{it.ubicacionLabel || (it.sinInventario ? 'Sin existencia' : '-')}</td>
                                                <td>
                                                    <CurrencyInput
                                                        value={it.precio}
                                                        decimalsLimit={3}
                                                        allowNegativeValue={false}
                                                        placeholder={`${prefMoneda} Venta`}
                                                        className="form-control"
                                                        prefix={`${prefMoneda} `}
                                                        groupSeparator=","
                                                        decimalSeparator="."
                                                        disabled={disabledAll}
                                                        onValueChange={(value) => {
                                                            const raw = value === undefined || value === null ? '' : value;
                                                            const v = raw === '' ? 0 : Number(raw);
                                                            setItems((prev) =>
                                                                prev.map((x) => {
                                                                    if (x.key !== it.key && x.productoId !== it.productoId) return x;
                                                                    const conv = Number(x.conversion || 1) || 1;
                                                                    return {
                                                                        ...x,
                                                                        precio: raw,
                                                                        precioBase: Number((v * conv).toFixed(6))
                                                                    };
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </td>
                                                <td className="text-center align-middle">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={!!it.iva}
                                                        disabled={disabledAll}
                                                        onChange={() => setItemField(it.key, 'iva', !it.iva)}
                                                    />
                                                </td>
                                                <td>
                                                    <div className="fw-semibold">
                                                        {it.sinInventario ? '-' : formatNumber(inventarioMostrado)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type="number"
                                                        value={it.cantidad}
                                                        min="0"
                                                        placeholder="Cantidad"
                                                        className={isOver ? 'is-invalid' : ''}
                                                        disabled={disabledAll}
                                                        onChange={(e) => {
                                                            const v = e.target.value === '' ? 0 : Number(e.target.value);
                                                            setItemField(it.key, 'cantidad', v);
                                                        }}
                                                    />
                                                    {isOver ? (
                                                        <div className="invalid-feedback d-block">
                                                            Excede inventario disponible
                                                        </div>
                                                    ) : null}
                                                </td>
                                                <td style={{ overflow: 'visible' }}>
                                                    {unidadesOptions.length > 0 ? (
                                                        <Select
                                                            placeholder="Unidad"
                                                            isDisabled={disabledAll}
                                                            value={unidadValue}
                                                            onChange={(opt) => onChangeUnidad(it.key, opt)}
                                                            options={unidadesOptions}
                                                            menuPortalTarget={menuPortalTarget}
                                                            menuPosition="fixed"
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                                            }}
                                                        />
                                                    ) : (
                                                        <Form.Control
                                                            type="text"
                                                            value="N/A"
                                                            disabled
                                                        />
                                                    )}
                                                </td>
                                                <td className="align-middle">
                                                    <div className="fw-semibold">{prefMoneda} {formatMoney(subtotal)}</div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="d-flex justify-content-center gap-2">
                                                        <Button
                                                            variant="outline-primary"
                                                            size="sm"
                                                            onClick={() => abrirPreciosProveedor(it)}
                                                            title="Ver precios del proveedor"
                                                            disabled={disabledAll}
                                                        >
                                                            <i className="fas fa-eye" />
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => eliminarItem(it.key)}
                                                            title="Eliminar"
                                                            disabled={disabledAll}
                                                        >
                                                            <i className="fas fa-trash" />
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Buscar paquetes</div>
                        {buscandoPaquetes ? <span className="text-muted" style={{ fontSize: 12 }}>Buscando...</span> : null}
                    </div>

                    <Row className="g-3 align-items-end">
                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Nombre o código</div>
                            <Form.Control
                                type="text"
                                placeholder="Nombre o código del paquete"
                                value={busquedaPaquete}
                                disabled={disabledAll}
                                onChange={(e) => setBusquedaPaquete(e.target.value)}
                            />
                        </Col>

                        <Col md={6}>
                            <div className="text-muted mb-1" style={{ fontSize: 12 }}>Paquete</div>
                            <Select
                                placeholder="Selecciona un paquete de los resultados..."
                                isDisabled={disabledAll}
                                value={null}
                                onChange={onSelectPaquete}
                                options={paquetesOptions}
                                isLoading={buscandoPaquetes}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                }}
                                noOptionsMessage={() =>
                                    buscandoPaquetes
                                        ? 'Buscando...'
                                        : ((busquedaPaquete || '').trim() ? 'Sin resultados' : 'Escribe para buscar')
                                }
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3" style={{ overflow: 'visible' }}>
                <Card.Body style={{ overflow: 'visible' }}>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="fw-semibold">Paquetes</div>
                    </div>

                    {paquetesItems.length === 0 ? (
                        <div className="text-muted" style={{ padding: '18px 0' }}>
                            Aún no hay paquetes. Busca uno y agrégalo.
                        </div>
                    ) : (
                        <div className="table-responsive" style={{ overflow: 'visible' }}>
                            <Table bordered hover className="mb-0" style={{ overflow: 'visible' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 30 }} />
                                        <th>Paquete</th>
                                        <th style={{ width: 190 }}>$ Venta</th>
                                        <th style={{ width: 70 }} className="text-center">IVA</th>
                                        <th style={{ width: 150 }}>Cantidad</th>
                                        <th style={{ width: 150 }}>Subtotal</th>
                                        <th style={{ width: 90 }}>Opciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paquetesItems.map((it) => {
                                        const cantidad = Number(it.cantidad || 0);
                                        const subtotal = Number(it.precio || 0) * cantidad * (it.iva ? 1.16 : 1);
                                        const componentes = Array.isArray(it.componentes) ? it.componentes : [];
                                        const abierto = !!paquetesExpandidos[it.key];

                                        return (
                                            <Fragment key={it.key}>
                                                <tr>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-link p-0"
                                                            onClick={() => togglePaqueteExpandido(it.key)}
                                                            title={abierto ? 'Ocultar productos del paquete' : 'Ver productos del paquete'}
                                                        >
                                                            <i className={`fas fa-chevron-${abierto ? 'down' : 'right'}`} />
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <div className="fw-semibold">{it.paqueteNombre}</div>
                                                        {it.paqueteCodigo ? (
                                                            <div className="text-muted" style={{ fontSize: 12 }}>{it.paqueteCodigo}</div>
                                                        ) : null}
                                                    </td>
                                                    <td>
                                                        <CurrencyInput
                                                            value={it.precio}
                                                            decimalsLimit={3}
                                                            allowNegativeValue={false}
                                                            placeholder={`${prefMoneda} Venta`}
                                                            className="form-control"
                                                            prefix={`${prefMoneda} `}
                                                            groupSeparator=","
                                                            decimalSeparator="."
                                                            disabled={disabledAll}
                                                            onValueChange={(value) => {
                                                                const raw = value === undefined || value === null ? '' : value;
                                                                setPaqueteItemField(it.key, 'precio', raw);
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={!!it.iva}
                                                            disabled={disabledAll}
                                                            onChange={() => setPaqueteItemField(it.key, 'iva', !it.iva)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type="number"
                                                            value={it.cantidad}
                                                            min="1"
                                                            placeholder="Cantidad"
                                                            disabled={disabledAll}
                                                            onChange={(e) => {
                                                                const v = e.target.value === '' ? 0 : Number(e.target.value);
                                                                setPaqueteItemField(it.key, 'cantidad', v);
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="align-middle">
                                                        <div className="fw-semibold">{prefMoneda} {formatMoney(subtotal)}</div>
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => eliminarPaqueteItem(it.key)}
                                                            title="Eliminar"
                                                            disabled={disabledAll}
                                                        >
                                                            <i className="fas fa-trash" />
                                                        </Button>
                                                    </td>
                                                </tr>
                                                {abierto && (
                                                    <tr>
                                                        <td />
                                                        <td colSpan={6} className="p-0">
                                                            <div className="table-responsive m-2">
                                                                <Table bordered size="sm" className="mb-0" style={{ fontSize: 13 }}>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Producto</th>
                                                                            <th className="text-center" style={{ width: 130 }}>Cantidad</th>
                                                                            <th style={{ width: 150 }}>Unidad</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {componentes.length === 0 ? (
                                                                            <tr>
                                                                                <td colSpan={3} className="text-muted text-center">Sin productos</td>
                                                                            </tr>
                                                                        ) : componentes.map((c) => {
                                                                            const conversion = Number(c?.conversion || 1) || 1;
                                                                            const necesaria = (Number(c?.cantidadPorPaquete || 0) * cantidad) / conversion;

                                                                            return (
                                                                                <tr key={c.productoId}>
                                                                                    <td>{c.productoNombre}</td>
                                                                                    <td className="text-center">{formatNumber(necesaria)}</td>
                                                                                    <td>{c.unidadNombre || '-'}</td>
                                                                                </tr>
                                                                            );
                                                                        })}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </Fragment>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </Card.Body>
            </Card>

            <div className="d-flex justify-content-between align-items-center gap-2 flex-wrap">
                <div className="text-muted" style={{ fontSize: 13 }}>
                    {items.length > 0 ? `Productos: ${items.length}` : null}
                    {paquetesItems.length > 0 ? ` · Paquetes: ${paquetesItems.length}` : null}
                </div>

                <div className="d-flex gap-2">
                    {!ventaCreada && (
                        <Button
                            variant="success"
                            onClick={registrarVenta}
                            disabled={disabledAll}
                        >
                            {esCotizacion ? 'Registrar cotización' : 'Registrar venta'}
                        </Button>
                    )}

                    {ventaCreada && (
                        <Fragment>
                            <Button
                                variant="primary"
                                onClick={() => window.location.reload()}
                            >
                                Registrar nueva venta
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => dispatch(generarPdfVenta(ventaCreada?._id))}
                            >
                                {esCotizacion ? 'Generar PDF cotización' : 'Generar PDF ticket'}
                            </Button>
                        </Fragment>
                    )}
                </div>
            </div>

            <AgregarClienteModal
                show={showNuevoCliente}
                onHide={() => setShowNuevoCliente(false)}
                onSave={guardarNuevoCliente}
                loading={savingCliente}
            />

            <SeleccionUbicacionesModal
                show={showUbicaciones}
                onHide={cerrarUbicaciones}
                onConfirm={onConfirmUbicaciones}
                producto={detalleActual}
                esCotizacion={esCotizacion}
                moneda={moneda}
                tipoCambio={getTc()}
            />

            <PreciosProveedorModal
                show={showPreciosProveedor}
                onHide={cerrarPreciosProveedor}
                productoNombre={preciosContexto.productoNombre}
                codigoTienda={preciosContexto.codigoTienda}
                precios={preciosContexto.precios}
                moneda={moneda}
                tipoCambio={getTc()}
            />

            <SeleccionPaqueteModal
                show={showSeleccionPaquete}
                onHide={cerrarSeleccionPaquete}
                onConfirm={onConfirmPaquete}
                paquete={paqueteActual}
                esCotizacion={esCotizacion}
                moneda={moneda}
                tipoCambio={getTc()}
            />
        </Fragment>
    );
}
